import React from 'react';

// components and helpers
import HomeDashboard from '../components/Home/HomeDashboard';
import ComponentWrapper from '../containers/ComponentWrapper';

export const HomeView: React.FC = () => {
    return <HomeDashboard />;
};

export default ComponentWrapper(HomeView);
